import {
  ICalendarHoliday,
  IUser,
  IVacationCarryOverRequest,
  IVacationCarryOverRequestComment,
  User,
  VacationCarryOverRequest,
  VacationCarryOverRequestComment
} from '@/models';
import { ITransition } from '@/models/transition';
import { IVacationCarryOverRequestState } from '@/store/vacation-carry-over-request';

import { IVacationCarryOverRequestGetters } from './getters.types';

export const getters: IVacationCarryOverRequestGetters = {
  getVacationCarryOverCount(state: IVacationCarryOverRequestState): number {
    return state.count;
  },

  getVacationCarryOverRequests(
    state: IVacationCarryOverRequestState
  ): IVacationCarryOverRequest[] {
    return state.vacationCarryOverRequests.map(
      data => new VacationCarryOverRequest(data)
    );
  },

  getVacationCarryOverRequestById: (state: IVacationCarryOverRequestState) => (
    id: number
  ): IVacationCarryOverRequest | undefined => {
    const data = state.vacationCarryOverRequests.find(
      vacationCarryOver => vacationCarryOver.id === id
    );
    if (!data) {
      return undefined;
    }

    return new VacationCarryOverRequest(data);
  },

  getVacationCarryOverRequestActivities: (
    state: IVacationCarryOverRequestState
  ): ITransition[] => {
    return state.activities;
  },

  getVacationCarryOverRequestComments: (
    state: IVacationCarryOverRequestState
  ): IVacationCarryOverRequestComment[] => {
    return state.comments.map(
      data => new VacationCarryOverRequestComment(data)
    );
  },

  getVacationCarryOverRequestCommentById: (
    state: IVacationCarryOverRequestState
  ) => (id: number): IVacationCarryOverRequestComment | undefined => {
    const data = state.comments.find(comment => comment.id === id);
    if (!data) {
      return undefined;
    }

    return new VacationCarryOverRequestComment(data);
  },

  getLastCreatedVacationCarryOverRequestCommentId(
    state: IVacationCarryOverRequestState
  ): number | null {
    return state.lastCreatedVacationCarryOverRequestCommentId;
  },

  // Mentions
  getVacationCarryOverRequestMentionableUsers(
    state: IVacationCarryOverRequestState
  ): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
